import Decimal from "decimal.js";

/** Complete signed decimal input, independent of the display locale.
 * A lone dot/comma is a decimal mark; with both, the last mark is decimal and
 * earlier marks must be valid three-digit grouping. Never coerce a draft to 0.
 */
export function parseDecimalAmount(value: string): Decimal | undefined {
  const text = value.trim().replaceAll("\u2212", "-");
  const sign = /^[+-]/.test(text) ? text[0] : "";
  const unsigned = sign ? text.slice(1) : text;
  const point = Math.max(unsigned.lastIndexOf("."), unsigned.lastIndexOf(","));
  const mark = point >= 0 ? unsigned[point] : undefined;
  const fraction = point >= 0 ? unsigned.slice(point + 1) : undefined;
  let integer = point >= 0 ? unsigned.slice(0, point) : unsigned;
  if (fraction !== undefined && !/^\d+$/.test(fraction)) return undefined;
  if (integer === "" && fraction !== undefined) integer = "0";
  if (!/^\d+$/.test(integer)) {
    // Keep grouping strict: malformed punctuation/spaces must not change money.
    if (mark && integer.includes(mark)) return undefined;
    if (!/^\d{1,3}([., \u00a0\u202f])\d{3}(?:\1\d{3})*$/.test(integer)) return undefined;
    integer = integer.replace(/[., \u00a0\u202f]/g, "");
  }
  return new Decimal(`${sign}${integer}${fraction === undefined ? "" : `.${fraction}`}`);
}
